module.exports = __webpack_public_path__ + "static/media/4ll14.62939fb9.png";